const GRID_PREFIX = 'common-grid';

/**
 * Build storage key
 */
const buildKey = (storageKey, key) => {
  return `${GRID_PREFIX}:${storageKey}:${key}`;
};

/**
 * Save Value
 * TO DO: Will do in database instead of localstorage
 */
export const saveGridState = (storageKey, key, value) => {
  try {
    localStorage.setItem(buildKey(storageKey, key), JSON.stringify(value));
  } catch (error) {
    console.error('Failed to save grid state', error);
  }
};

/**
 * Load Value
 */
export const loadGridState = (storageKey, key, defaultValue = null) => {
  try {
    const value = localStorage.getItem(buildKey(storageKey, key));

    if (value === null || value === undefined) {
      return defaultValue;
    }

    return JSON.parse(value);
  } catch (error) {
    console.error('Failed to load grid state', error);

    return defaultValue;
  }
};

/**
 * Remove Single State
 */
export const removeGridState = (storageKey, key) => {
  try {
    localStorage.removeItem(buildKey(storageKey, key));
  } catch (error) {
    console.error('Failed to remove grid state', error);
  }
};

/**
 * Clear Entire Grid State
 */
export const clearGridState = (storageKey) => {
  try {
    const prefix = `${GRID_PREFIX}:${storageKey}:`;

    Object.keys(localStorage).forEach((localStorageKey) => {
      if (localStorageKey.startsWith(prefix)) {
        localStorage.removeItem(localStorageKey);
      }
    });
  } catch (error) {
    console.error('Failed to clear grid state', error);
  }
};

/**
 * PERSIST Keys
 */
export const GRID_PERSIST_KEYS = {
  PAGE_SIZE: 'pageSize',
  DENSITY: 'density',
  COLUMN_VISIBILITY: 'columnVisibility',
  COLUMN_WIDTHS: 'columnwidths',
  SORT_MODEL: 'sortModel',
  FILTERS: 'filters',
  SEARCH_TEXT: 'searchText',
  COLUMN_SEARCH: 'columnSearch',
  PINNED_COLUMNS: 'pinnedColumns',
};
